const Apresentacao = () => import('~/pages/apresentacao').then(m => m.default || m)
const Assistencia = () => import('~/pages/assistencia').then(m => m.default || m)
const Creditos = () => import('~/pages/creditos').then(m => m.default || m)
const Atualizacoes = () => import('~/pages/atualizacoes').then(m => m.default || m)
const Mapa = () => import('~/pages/mapa').then(m => m.default || m)
const LMapa = () => import('~/pages/lmapa').then(m => m.default || m)
const Painel = () => import('~/pages/painel').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Dashboard = () => import('~/pages/dashboard').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile/index').then(m => m.default || m)

const Permissao = () => import('~/pages/admin/permissao').then(m => m.default || m)
const User = () => import('~/pages/admin/user').then(m => m.default || m)
const Conteudo = () => import('~/pages/admin/conteudo').then(m => m.default || m)
const Atualizacao = () => import('~/pages/admin/atualizacao').then(m => m.default || m)
const Bairro = () => import('~/pages/admin/bairro').then(m => m.default || m)
const Secretaria = () => import('~/pages/admin/secretaria').then(m => m.default || m)

const Cras = () => import('~/pages/admin/cras').then(m => m.default || m)
const Creas = () => import('~/pages/admin/creas').then(m => m.default || m)
const ConselhoTutelar = () => import('~/pages/admin/conselhoTutelar').then(m => m.default || m)

const Unidade = () => import('~/pages/admin/unidade').then(m => m.default || m)
const UnidadeCategoria = () => import('~/pages/admin/unidadeCategoria').then(m => m.default || m)
const Indicador = () => import('~/pages/admin/indicador').then(m => m.default || m)
const IndicadorCategoria = () => import('~/pages/admin/indicadorCategoria').then(m => m.default || m)
const IndicadorSegmento = () => import('~/pages/admin/indicadorSegmento').then(m => m.default || m)
const Informacoes = () => import('~/pages/admin/informacoes').then(m => m.default || m)
const Funcionario = () => import('~/pages/admin/funcionario').then(m => m.default || m)
const CargaHoraria = () => import('~/pages/admin/cargahoraria').then(m => m.default || m)
const Cargo = () => import('~/pages/admin/cargo').then(m => m.default || m)
const Escolaridade = () => import('~/pages/admin/escolaridade').then(m => m.default || m)
const FontePagadora = () => import('~/pages/admin/fontepagadora').then(m => m.default || m)
const Funcao = () => import('~/pages/admin/funcao').then(m => m.default || m)
const Posgraduacao = () => import('~/pages/admin/posgraduacao').then(m => m.default || m)
const Profissao = () => import('~/pages/admin/profissao').then(m => m.default || m)
const Servico = () => import('~/pages/admin/servico').then(m => m.default || m)
const Status = () => import('~/pages/admin/status').then(m => m.default || m)
const Vinculo = () => import('~/pages/admin/vinculo').then(m => m.default || m)
const CorRaca = () => import('~/pages/admin/corRaca').then(m => m.default || m)
const Graduacao = () => import('~/pages/admin/graduacao').then(m => m.default || m)
const Beneficio = () => import('~/pages/admin/beneficio').then(m => m.default || m)


export default [
    { path: '/', name: 'apresentacao', component: Apresentacao},
    { path: '/assistencia', name: 'assistencia', component: Assistencia},
    { path: '/creditos', name: 'creditos', component: Creditos},
    { path: '/atualizacoes', name: 'atualizacoes', component: Atualizacoes},
    { path: '/mapa', name: 'mapa', component: Mapa},
    { path: '/lmapa', name: 'lmapa', component: LMapa},
    { path: '/painel', name: 'painel', component: Painel},
    { path: '/admin', name: 'login', component: Login },
    { path: '/register', name: 'register', component: Register },
    { path: '/password/reset', name: 'password.request', component: PasswordEmail },
    { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

    { path: '/dashboard', name: 'dashboard', component: Dashboard },
    {
        path: '/settings',
        component: Settings,
        children: [
            { path: '', redirect: { name: 'settings.profile' } },
            { path: 'profile', name: 'settings.profile', component: SettingsProfile }
        ]
    },

    { path: '/', redirect: { name: 'dashboard' } },
    { path: '*', component: NotFound },

    { path: '/admin/permissao', name: 'permissao', component: Permissao },
    { path: '/admin/user', name: 'user', component: User },
    { path: '/admin/conteudo', name: 'conteudo', component: Conteudo },
    { path: '/admin/cras', name: 'cras', component: Cras },
    { path: '/admin/creas', name: 'creas', component: Creas },
    { path: '/admin/conselhoTutelar', name: 'conselhoTutelar', component: ConselhoTutelar },
    { path: '/admin/atualizacao', name: 'atualizacao', component: Atualizacao },
    { path: '/admin/unidade', name: 'unidade', component: Unidade },
    { path: '/admin/unidadeCategoria', name: 'unidadeCategoria', component: UnidadeCategoria },
    { path: '/admin/bairro', name: 'bairro', component: Bairro },
    { path: '/admin/secretaria', name: 'secretaria', component: Secretaria },
    { path: '/admin/indicador', name: 'indicador', component: Indicador },
    { path: '/admin/indicadorCategoria', name: 'indicadorCategoria', component: IndicadorCategoria },
    { path: '/admin/indicadorSegmento', name: 'indicadorSegmento', component: IndicadorSegmento },
    { path: '/admin/informacoes', name: 'informacoes', component: Informacoes },
    { path: '/admin/funcionario', name: 'funcionario', component: Funcionario },
    { path: '/admin/carga-horaria', name: 'cargaHoraria', component: CargaHoraria },
    { path: '/admin/cargo', name: 'cargo', component: Cargo },
    { path: '/admin/escolaridade', name: 'escolaridade', component: Escolaridade },
    { path: '/admin/fonte-pagadora', name: 'fontePagadora', component: FontePagadora },
    { path: '/admin/funcao', name: 'funcao', component: Funcao },
    { path: '/admin/posgraduacao', name: 'posgraduacao', component: Posgraduacao },
    { path: '/admin/profissao', name: 'profissao', component: Profissao },
    { path: '/admin/servico', name: 'servico', component: Servico },
    { path: '/admin/status', name: 'status', component: Status },
    { path: '/admin/vinculo', name: 'vinculo', component: Vinculo },
    { path: '/admin/corRaca', name: 'corRaca', component: CorRaca },
    { path: '/admin/graduacao', name: 'graduacao', component: Graduacao },
    { path: '/admin/beneficio', name: 'beneficio', component: Beneficio }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js